import { Ship } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-200 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex items-center justify-center h-8 w-8 rounded-lg bg-[#0B1F3A] text-white">
                <Ship className="h-4 w-4" />
              </span>
              <span className="font-display font-extrabold text-lg tracking-tight text-[#0B1F3A]">
                DeMaxtore
              </span>
            </div>
            <p className="mt-4 text-sm text-slate-500 max-w-sm">
              The modern logistics operating system for global importers
              shipping from Turkey.
            </p>
            <nav className="mt-6 text-xs text-slate-400" aria-label="Breadcrumb">
              <ol className="flex flex-wrap items-center gap-1.5">
                <li>
                  <a href="/" className="hover:text-[#0B1F3A]">
                    Home
                  </a>
                </li>
                <li>/</li>
                <li>
                  <a href="#" className="hover:text-[#0B1F3A]">
                    Solutions
                  </a>
                </li>
                <li>/</li>
                <li className="text-[#0B1F3A] font-medium">
                  Freight Booking from Turkey
                </li>
              </ol>
            </nav>
          </div>

          {[
            {
              t: "Platform",
              items: [
                { l: "FreightIQ™", h: "#freightiq" },
                { l: "Live Shipment Tracking™", h: "#tracking" },
                { l: "Inspection™", h: "#inspection" },
                { l: "Workspace", h: "#workspace" },
              ],
            },
            {
              t: "Solutions",
              items: [
                { l: "Freight Booking from Turkey", h: "#top" },
                { l: "Ocean Freight Booking", h: "#freightiq" },
                { l: "Container Booking", h: "#freightiq" },
                { l: "Sea Freight from Turkey", h: "#freightiq" },
              ],
            },
            {
              t: "Resources",
              items: [
                { l: "FAQ", h: "#faq" },
                { l: "Why DeMaxtore", h: "#features" },
                { l: "Integrations", h: "#workspace" },
              ],
            },
          ].map((col) => (
            <div key={col.t}>
              <div className="text-[10px] tracking-[0.18em] uppercase font-bold text-slate-400">
                {col.t}
              </div>
              <ul className="mt-4 space-y-3">
                {col.items.map((i) => (
                  <li key={i.l}>
                    <a
                      href={i.h}
                      className="text-sm text-slate-600 hover:text-[#0B1F3A] transition-colors"
                    >
                      {i.l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-6 border-t border-slate-100 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-slate-400 font-mono">
            © {new Date().getFullYear()} DeMaxtore · All rights reserved
          </div>
          <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-slate-300">
            A modern logistics operating system
          </div>
        </div>
      </div>
    </footer>
  );
}
